import { render, staticRenderFns } from "./image-viewer.vue?vue&type=template&id=76474072&scoped=true"
import script from "./image-viewer.ts?vue&type=script&lang=ts&external"
export * from "./image-viewer.ts?vue&type=script&lang=ts&external"
import style0 from "./image-viewer.less?vue&type=style&index=0&id=76474072&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76474072",
  null
  
)

export default component.exports